var exports = {
  "y": "titleInputWrapper__8WOU5l",
};

module.exports = exports;
